type GetTextWithHighlightFragmentOptions = {
  tag?: string;
  className?: string;
};

const getTextWithHighlightFragment = (
  text: string,
  highlightFraction: string,
  {
    tag = 'span',
    className = '',
  }: GetTextWithHighlightFragmentOptions): string => {
  const regExp = new RegExp(`(${highlightFraction.trim()})`, 'gi');
  const replaced = `<${tag}${className ? ` class="${className}"` : ' '} data-test="item-highlight">$1</${tag}>`;
  return text.replaceAll(regExp, replaced);
};

export default getTextWithHighlightFragment;
